/** Full-page navigation to JSP staff routes from the Peppar Merchant WebView. */
export async function navigateToStaffRoute(path: string): Promise<void> {
  const nativeApi = (window as Window & {
    MenuBeezNative?: {
      staffAlerts?: {
        syncCookies?: (opts: { baseUrl: string }) => Promise<unknown>;
        flushWebViewCookies?: () => Promise<unknown>;
      };
    };
  }).MenuBeezNative;

  if (nativeApi?.staffAlerts?.syncCookies) {
    try {
      await nativeApi.staffAlerts.syncCookies({ baseUrl: window.location.origin });
    } catch {
      // Best-effort before full-page navigation.
    }
  }
  if (nativeApi?.staffAlerts?.flushWebViewCookies) {
    try {
      await nativeApi.staffAlerts.flushWebViewCookies();
    } catch {
      // Best-effort before full-page navigation.
    }
  }

  await new Promise<void>((resolve) => setTimeout(resolve, 350));
  window.location.assign(path);
}
